import toast from 'react-hot-toast';

export { toast };

export const showToast = {
  success: (message: string) => {
    return toast.success(message, {
      style: {
        border: '1px solid #10B981',
        padding: '16px',
        color: '#065F46',
        background: '#ECFDF5',
      },
      iconTheme: {
        primary: '#10B981',
        secondary: '#ECFDF5',
      },
    });
  },

  error: (message: string) => {
    return toast.error(message, {
      style: {
        border: '1px solid #EF4444',
        padding: '16px',
        color: '#991B1B',
        background: '#FEF2F2',
      },
      iconTheme: {
        primary: '#EF4444',
        secondary: '#FEF2F2',
      },
    });
  },

  loading: (message: string) => {
    return toast.loading(message, {
      style: {
        border: '1px solid #3B82F6',
        padding: '16px',
        color: '#1E40AF',
        background: '#EFF6FF',
      },
    });
  },

  info: (message: string) => {
    return toast(message, {
      icon: 'ℹ️',
      style: {
        border: '1px solid #3B82F6',
        padding: '16px',
        color: '#1E40AF',
        background: '#EFF6FF',
      },
    });
  },

  warning: (message: string) => {
    return toast(message, {
      icon: '⚠️',
      style: {
        border: '1px solid #F59E0B',
        padding: '16px',
        color: '#92400E',
        background: '#FFFBEB',
      },
    });
  },

  // Custom toast with promise handling
  promise: <T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    }
  ) => {
    return toast.promise(promise, messages, {
      success: {
        style: {
          border: '1px solid #10B981',
          padding: '16px',
          color: '#065F46',
          background: '#ECFDF5',
        },
      },
      error: {
        style: {
          border: '1px solid #EF4444',
          padding: '16px',
          color: '#991B1B',
          background: '#FEF2F2',
        },
      },
    });
  },

  // Dismiss specific toast
  dismiss: (toastId: string) => {
    toast.dismiss(toastId);
  },

  // Dismiss all toasts
  dismissAll: () => {
    toast.dismiss();
  },
};